import React from 'react';

export const Card = ({ children, className = '' }) => {
  return (
    <div className={`bg-white rounded-xl shadow p-4 border ${className}`}>
      {children}
    </div>
  );
};
